
export type SolvePanelPlacementResponseErrorCode = typeof SolvePanelPlacementResponseErrorCode[keyof typeof SolvePanelPlacementResponseErrorCode];


export const SolvePanelPlacementResponseErrorCode = {
  None: 'None',
  ValidationFailed: 'ValidationFailed',
  InfeasiblePlacement: 'InfeasiblePlacement',
  InfeasibleGapMode: 'InfeasibleGapMode',
  LockedConflict: 'LockedConflict',
  MaterialUnavailable: 'MaterialUnavailable',
  FaultyPrefabData: 'FaultyPrefabData',
  NotImplemented: 'NotImplemented',
} as const;
